<script setup lang="ts">
import { ActionMenuButton, type EditorIconType } from '@/components/editor'
import { ButtonViewReturnComponentProps } from '@/types'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/ui'
import { cn } from '@/utils'

interface Props {
  icon?: EditorIconType
  title?: string
  tooltip?: string
  disabled?: boolean
  class?: string
  btnClass?: string
  action?: ButtonViewReturnComponentProps['action']
  isActive?: ButtonViewReturnComponentProps['isActive']
}

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  title: undefined,
  tooltip: undefined,
  disabled: false,
  action: undefined,
  isActive: undefined,
  class: '',
  btnClass: '',
})
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger :disabled="disabled">
      <ActionMenuButton
        :class="btnClass"
        :title="title"
        :icon="icon"
        :tooltip="tooltip"
        :disabled="disabled"
        :is-active="isActive"
      />
    </DropdownMenuTrigger>
    <DropdownMenuContent :class="cn('min-w-24', props.class)" align="start" side="bottom" v-bind="$attrs">
      <slot />
    </DropdownMenuContent>
  </DropdownMenu>
</template>
